import { Box, Container } from '@mui/material';
import React from 'react';
import RequestsTable from '../../../components/requeststable/requeststable.component';
import './myrequests.page.css';

const MyRequests = () => {
  return (
    <Container className='doc-cat-content requests-page'>
        {/* <Box>
            <Typography className='ext-large-brown-txt'>
                My Requests
            </Typography>
        </Box> */}
        <Box><RequestsTable /></Box>
    </Container>
  );
};

export default MyRequests;